angular.module('custom-validator', [])
    .directive('customValidator', function() {
        return {
            restrict: 'A',
            require: 'ngModel',
            scope: {
                validator: '&',
                validatorWatch: '<',
            },
            link: function (scope, element, attrs, ngModelCtrl) {
                if (attrs.validatorWatch) {
                    scope.$watch(function() {
                        return scope.validatorWatch;
                    }, function(newValue, oldValue) {
                        if (newValue != oldValue) {
                            var currentValue = ngModelCtrl.$viewValue;
                            var isDirty = ngModelCtrl.$dirty;
                            // A change is done in current field to force parsers to be executed
                            ngModelCtrl.$setViewValue(null);
                            ngModelCtrl.$setViewValue(currentValue);
                            // If field was not dirty before this forced change, set it as pristine
                            if (!isDirty) {
                                ngModelCtrl.$setPristine();
                            }
                        }
                    });
                }

                ngModelCtrl.$parsers.push(function(value) {
                    var result = scope.validator({ value: value });

                    if (result && result.then) {
                        return result
                            .then(function(valid) {
                                ngModelCtrl.$setValidity(attrs.customValidator, !!valid);
                            })
                            .catch(function(error) {
                                ngModelCtrl.$setValidity(attrs.customValidator, false);
                            })
                            .then(function() {
                                return value;
                            });
                    }
                    // If validator is sync
                    else {
                        ngModelCtrl.$setValidity(attrs.customValidator, !!result);

                        return value;
                    }
                });
            }
        };
    });
